// extracted by mini-css-extract-plugin
export var date = "newsletter-top-level-module--date--0fc31";
export var grid = "newsletter-top-level-module--grid--6a1eb";
export var headliner = "newsletter-top-level-module--headliner--972bb";
export var headliner__black = "newsletter-top-level-module--headliner__black--fad84";
export var headliner__bloodorange = "newsletter-top-level-module--headliner__bloodorange--ff257";
export var headliner__chartruse = "newsletter-top-level-module--headliner__chartruse--9afcf";
export var headliner__cobalt = "newsletter-top-level-module--headliner__cobalt--8ad26";
export var headliner__emerald = "newsletter-top-level-module--headliner__emerald--7cccc";
export var headliner__paper = "newsletter-top-level-module--headliner__paper--b553a";
export var headliner__pink = "newsletter-top-level-module--headliner__pink--d1c93";
export var headliner__sky = "newsletter-top-level-module--headliner__sky--322bf";
export var headliner__white = "newsletter-top-level-module--headliner__white--e9700";
export var left = "newsletter-top-level-module--left--7a7fa";
export var left__lifestyle = "newsletter-top-level-module--left__lifestyle--78196";
export var partner = "newsletter-top-level-module--partner--992dd";
export var partnerLogo = "newsletter-top-level-module--partnerLogo--41dba";
export var partnerLogo__lifestyle = "newsletter-top-level-module--partnerLogo__lifestyle--e3932";
export var partner__contain = "newsletter-top-level-module--partner__contain--6ca2d";
export var right = "newsletter-top-level-module--right--50486";
export var right__lifestyle = "newsletter-top-level-module--right__lifestyle--76a31";
export var small = "newsletter-top-level-module--small--cb5d2";
export var spin = "newsletter-top-level-module--spin--e693a";